import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import utils from "../../Utils";
import "bootstrap/dist/css/bootstrap.css";
import "./dashboardCalendar.css";
import strings from "../../Utils/strings";
import constants from "../../Utils/constants";
import clinicService from "../../Services/clinicService";
import utilFunctions from "../../Utils/utilFunctions";
import toast from "react-hot-toast";
import classNames from "classnames";
import moment from "moment";
import Widgets from "..";
import authService from "../../Services/authService";
import { useSelector } from "react-redux";

const DashboardCalender = (props) => {
  const [value, setValue] = useState(new Date());
  const isRefresh = useSelector((state) => state.refreshNoti.refreshNoti);
  const [selectedDate, setSelectedDate] = useState("");
  const [appointment, setAppointment] = useState(false);
  const [appointmentRequest, setAppointmentRequest] = useState(false);
  const [doctorAvailable, setDoctorAvailable] = useState(false);
  const [cardBGColorClass, setCardBGColorClass] = useState("");
  const [leaveCount, setLeaveCount] = useState([]);
  const [calenderDetails, setCalenderDetails] = useState([]);
  const [appointmentRequestCount, setAppointmentRequestCount] = useState([]);
  const [workingCount, setWorkingCount] = useState(0);
  const [selectedDateValue, setSelectedDateValue] = useState("");
  const [monthStartDate, setMonthStartDate] = useState("");
  const [clinicOnLeave, setClinicOnLeave] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [prevTitle, setPrevTitle] = useState("");

  const [selectedLang, setSelectedLang] = useState("en-US");

  useEffect(() => {
    const savedLanguage = localStorage.getItem("i18nextLng") || "en";
    if (savedLanguage === "vietnam") setSelectedLang("vi");
  }, []);

  useEffect(() => {
    setPrevTitle(props.titleChange);
  }, [props.titleChange]);

  useEffect(() => {
    if (prevTitle !== props.prevTitle) {
      const monthNumber = parseInt(moment(value).format(constants.dashboardType.monthFormat));
      const year = moment(value).format(constants.dashboardType.year);
      getAppointmentCalender(monthNumber, year);
    }
  }, [prevTitle]);

  useEffect(() => {
    const monthNumber = parseInt(moment(value).format(constants.dashboardType.monthFormat));
    const year = moment(value).format(constants.dashboardType.year);
    // getAppointmentCalender(monthNumber, year);
  }, [props.monthChange]);
  // sachin
  const formattedMonth = new Intl.DateTimeFormat(selectedLang, {
    month: strings.clinicDashboard.long,
    year: strings.clinicDashboard.numeric,
  }).format(value);

  useEffect(() => {
    const currentDate = moment().format(constants.dateFormat.standardDate);
    setSelectedDate(currentDate);
    setSelectedDateValue(currentDate);
    props.func(currentDate);
    const monthNumber = parseInt(moment(value).format(constants.dashboardType.monthFormat));
    const year = moment(value).format(constants.dashboardType.year);
    // getAppointmentCalender(monthNumber, year);
  }, []);

  useEffect(() => {
    const classToApply =
      props.titleChange == constants.dashboardType.appointment
        ? "card-bg-color-appointment"
        : props.titleChange == constants.dashboardType.doctorAvailability
          ? "card-bg-color-appointment-doctor-availbility"
          : props.titleChange == constants.dashboardType.appointmentRequest
            ? "card-bg-color-appointment-request"
            : "card-bg-color-appointment-request";
    setCardBGColorClass(classToApply);
  }, [props.titleChange]);

  const handleDateChange = (date, event) => {
    // console.log("changed date", date.toDateString());
    setValue(date);
    setSelectedDate(`strings.clinicDashboard.selectedDate ${date.toDateString()}`);
    setMonthStartDate(value);
    props.onCalenderChange(true);
  };

  function handleMonthChange(month) {
    const monthNumber = parseInt(moment(value).format(constants.dashboardType.monthFormat));
    let newMonthNumber;
    if (month > 0) {
      newMonthNumber = monthNumber + month;
      if (newMonthNumber > 12) {
        newMonthNumber -= 12;
      }
    } else if (month < 0) {
      newMonthNumber = monthNumber - Math.abs(month);
      if (newMonthNumber < 1) {
        newMonthNumber += 12;
      }
    } else {
      return;
    }

    const year = moment(value).format(constants.dashboardType.year);
    const formattedDate = moment(value).add(month, constants.dashboardType.month).format(constants.dateFormat.standardDate);
    props.monthChange(formattedDate);
    setMonthStartDate(value);

    setValue((prevDate) => {
      const newDate = new Date(prevDate.getTime());
      newDate.setMonth(prevDate.getMonth() + month, 1);
      newDate.setDate(1);
      props.func(moment(newDate).format(constants.dateFormat.standardDate));
      return newDate;
    });
    props.monthChange(formattedDate);
    getAppointmentCalender(newMonthNumber, year);
  }
  const getAppointmentCalender = async (monthNumber, year, load) => {
    if(load !== "load"){
        setIsLoading(true);
      }
    const apiParams = {
      appointmentRequest: ["WAITING_FOR_CLINIC_CONFIRMATION", "CONFIRMED"],
      appointment: ["SCHEDULED", "STARTED", "COMPLETED"],
      doctorAvailability: ["WAITING_FOR_CLINIC_CONFIRMATION", "CONFIRMED", "SCHEDULED", "STARTED", "COMPLETED"],
    };

    const selectedArray =
      props.titleChange === "appointmentRequest"
        ? apiParams.appointmentRequest
        : props.titleChange === "appointment"
          ? apiParams.appointment
          : props.titleChange === "doctorAvailability"
            ? apiParams.doctorAvailability
            : apiParams.appointmentRequest;

    try {
      if (!monthNumber || !year) return;
      const formattedMonth = String(monthNumber).padStart(2, "0");
      let response;

      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.docGetAppointmentCalender(formattedMonth, year, selectedArray);
      } else if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.getAppointmentCalender(formattedMonth, year, selectedArray);
      }

      if (response && response.status && response.data && Array.isArray(response.data.calendar)) {
        const updatedAppointmentrequestDetails = response.data.calendar.map((detail) => ({
          ...detail,
          appointmentDate: moment(detail.date, constants.dateFormat.standardDate).toDate(),
        }));
        setAppointmentRequestCount(updatedAppointmentrequestDetails);

        const updatedCalendarDetails = response.data.calendar.map((detail) => ({
          ...detail,
          appointmentDate: moment(detail.date, constants.dateFormat.standardDate).toDate(),
        }));
        setCalenderDetails(updatedCalendarDetails);
        // console.log("updated calendar details", updatedCalendarDetails);
      } else {
        setLeaveCount([]);
        setWorkingCount(0);
        setCalenderDetails([]);
        setAppointmentRequestCount([]);
      }
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

    useEffect(() => {
      const monthNumber = parseInt(moment(value).format(constants.dashboardType.monthFormat));
      const year = moment(value).format(constants.dashboardType.year);
      getAppointmentCalender(monthNumber, year, "load");
    }, [isRefresh]);

  const renderCallIcons = (details) => {
    if (details && details.count) {
      return (
        <React.Fragment>
          <div className="icon-container d-flex justify-content-center mt-1" data-toggle="tooltip" title={strings.clinicDashboard.videoCall}>
            {details.count !== 0 && (
              <>
                <i className="video-call-type ri-live-fill calendar-icons me-3"></i>
                <span className="count">{utilFunctions.formatCount(details.count)}</span>
              </>
            )}
          </div>
        </React.Fragment>
      );
    } else {
      return null;
    }
  };

  const tileContent = ({ date, view }) => {
    const formattedDate = date.toLocaleDateString();
    const currentDateFormatted = moment(date).format("YYYY-MM-DD");
    // console.log(currentDateFormatted, calenderDetails[0]?.date)
    const matchingDetails = calenderDetails.find((detail) => detail?.date === currentDateFormatted);
    // console.log("matching detaisl", matchingDetails)
    const matchingAppointmentRequestDetails = appointmentRequestCount.find((detail) => detail.appointmentDate.toLocaleDateString() === currentDateFormatted);
    const matchingLeaveDetails = leaveCount.find((detail) => detail.leaveDate.toLocaleDateString() === currentDateFormatted);

    let appointmentRequest = props.titleChange === "" ? constants.dashboardType.appointmentRequest : props.titleChange;

    if (view === constants.dashboardType.month) {
      if (date.getDate()) {
        let dateValue = moment(date).format(utils.constants.dateFormat.standardDate);
        let currDate = moment(new Date()).format(utils.constants.dateFormat.standardDate);
        let selectedDate = moment(value).format(utils.constants.dateFormat.standardDate);

        let calendarClass = "";
        let appointmentClass = "";
        let doctorClass = "";

        if (dateValue === selectedDate) {
          calendarClass = "calendar-icons-selected-appointment-request";
          setAppointmentRequest(true);
          appointmentClass = "calendar-icons-selected-appointment";
          setAppointment(true);
          doctorClass = "calendar-icons-selected-doctor";
          setDoctorAvailable(true);
        } else {
          if (selectedDate === currDate) {
            calendarClass = "calendar-icons-current-date-appointment-request";
            setAppointmentRequest(false);
            appointmentClass = "calendar-icons-current-date-appointment";
            setAppointment(false);
            doctorClass = "calendar-icons-current-date-doctor";
          } else {
            calendarClass = "calendar-icons-unselected-appointment-request";
            appointmentClass = "calendar-icons-current-date-appointment";
            setAppointment(true);
            doctorClass = "calendar-icons-unselected-doctor";
          }
        }

        let buttonClass =
          props.titleChange === " "
            ? calendarClass
            : props.titleChange === constants.dashboardType.appointment
              ? appointmentClass
              : props.titleChange === constants.dashboardType.doctorAvailability
                ? doctorClass
                : calendarClass;
        return (
          <div className={clinicOnLeave.includes(currentDateFormatted) ? "clinic-leave" : buttonClass}>
            {props.titleChange === constants.dashboardType.appointment ? (
              <div>{renderCallIcons(matchingDetails)}</div>
            ) : appointmentRequest === constants.dashboardType.appointmentRequest ? (
              <div>{renderCallIcons(matchingDetails)}</div>
            ) : props.titleChange === constants.dashboardType.doctorAvailability ? (
              <div>{renderCallIcons(matchingDetails)}</div>
            ) : (
              <div>{renderCallIcons(matchingDetails)}</div>
            )}
          </div>
        );
      }
    }
  };

  return (
    <React.Fragment>
      {isLoading ? <Widgets.CircularLoader /> : ""}
      <div className=" col-12 d-flex text-center align-items-center">
        <div className="col-1 col-sm-2 col-md-auto month" style={{ marginLeft: "-.5rem" }}>
          <span data-toggle="tooltip" title={strings.clinicDashboard.previous}>
            <i
              className="ri-arrow-left-s-line icon-hover-bg calendar-arrow dashboard-arrow-left"
              value={monthStartDate}
              onClick={() => {
                handleMonthChange(-1);
              }}
            ></i>
          </span>
        </div>
        <div className="col-3 col-sm-8 col-md-auto text-nowrap month-name" style={{ marginLeft: ".5rem" }}>
          {formattedMonth}
        </div>
        <div className="col-1 col-sm-2 col-md-auto month" style={{ marginLeft: "-.5rem" }}>
          <span data-toggle="tooltip" title={strings.clinicDashboard.next}>
            <i
              className="ri-arrow-right-s-line icon-hover-bg calendar-arrow dashboard-arrow-right"
              value={monthStartDate}
              onClick={() => {
                handleMonthChange(1);
              }}
            ></i>
          </span>
        </div>
      </div>
      <div className={classNames(props.pendingAppointmentCount > 0 ? "calendar mt-2" : "mt-2")}>
        <Calendar
          locale={selectedLang}
          className={(appointment ? "appointment-class" : appointmentRequest ? "appointment-request" : doctorAvailable ? "doctor-available" : "appointment-class", cardBGColorClass)}
          value={value}
          activeStartDate={moment(value).startOf(constants.dashboardType.month).toDate()}
          onChange={(value) => {
            handleDateChange(value);
          }}
          tileContent={tileContent}
          onClickDay={(value) => {
            const formattedDate = moment(value, constants.dashboardType.dateFormat).format(constants.dateFormat.standardDate);
            setSelectedDateValue(formattedDate);
            setMonthStartDate(value);
            props.func(formattedDate);
          }}
        />
      </div>
    </React.Fragment>
  );
};

export default DashboardCalender;
